module.exports = __webpack_public_path__ + "static/media/two-kids-stirring-laugh.bc5e252c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2017-11-4/two-kids-stirring-laugh.jpg
// module id = 816
// module chunks = 0